import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthFlowFrame from "../../components/AuthFlowFrame";
import SidePanel from "../../components/SidePanel";
import { AuthFlowButton } from "../../types";
import { showError } from "../../helpers";
import { instagramRedirectUrl } from "../../services";
import { Content } from "@jobber/components/Content";
import { Heading } from "@jobber/components/Heading";
import { Link } from "@jobber/components/Link";
import { Text } from "@jobber/components/Text";

const PROFESSIONAL_ACCOUNT_HELP_URL =
    "https://help.instagram.com/502981923235522";

function Step1() {
    const [buttonLink, setButtonLink] = useState("");
    const location = useLocation();

    useEffect(() => {
        if (location.state?.error) {
            const onRetry = async () => {
                const state = sessionStorage.getItem('state');
                if (!state) return;
                const { redirect_url } = await instagramRedirectUrl(state);
                window.location.assign(redirect_url);
            };
            showError(location.state.error, onRetry);
        }
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const state = sessionStorage.getItem('state');
                if (!state) {
                    throw new Error("Missing session state — please restart the setup flow.");
                }
                const { redirect_url } = await instagramRedirectUrl(state);
                setButtonLink(redirect_url);
            } catch(e: any) {
                showError("Error establishing connection with Instagram: " + e.message);
            }
        })();
    }, []);


    const button: AuthFlowButton = {
        link: buttonLink,
        text: "Connect to Instagram",
        type: "primary",
        disabled: false,
        loading: false,
    }

    const sidePanel = (
        <SidePanel>
            <Heading level={4}>Before you start</Heading>
            <Text size={"base"}>
                Your Instagram account must be a <b>Business</b> or <b>Creator</b> account.
                Personal accounts can't publish posts through Instagram's API.
            </Text>
            <Text size={"base"} variation={"subdued"}>
                Switching is free and takes a minute in the Instagram app —{" "}
                <Link url={PROFESSIONAL_ACCOUNT_HELP_URL} external={true}>
                    see how to switch to a professional account
                </Link>, then come back to this tab.
            </Text>
        </SidePanel>
    );

    return (
        <AuthFlowFrame
            pretitle={"Let's get you set up"}
            title={"Connect to Instagram"}
            step={1}
            totalSteps={2}
            button={button}
            sidePanel={sidePanel}
        >
            <Content spacing={"base"}>
                <Text size={"large"}>
                    After connecting your Instagram account, your integration will be ready to go!
                </Text>
                <Text size={"base"} variation={"subdued"}>
                    You'll be sent to Instagram to sign in and approve access. Make sure you're
                    signed in as the account you want your Jobber posts published to.
                </Text>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step1;
